import { StringUtils } from 'src/app/services/utils/string.utils';

export class BusinessPropertiesObject {

    constructor(private serviceId: string, private crmId: string) {
    }

    static create(): BusinessPropertiesObject {
        return new BusinessPropertiesObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
    }

    public getServiceId() {
        return this.serviceId;
    }

    public getCrmId() {
        return this.crmId;
    }
}
